import React from "react";
import { MDBContainer, MDBBox, MDBRow } from "mdbreact";
import {
  UpcomingImage,
  UpcomingContent,
} from "./upcoming-section-query-container";
const UpcomingSectionV2 = (props) => {
  return (
    <MDBContainer fluid className="upcoming-main-container">
      <MDBRow>
        <MDBBox className="upcoming-container">
          <MDBBox>
            <UpcomingImage />
          </MDBBox>
          <MDBBox className="upcoming-text">
            <UpcomingContent />
          </MDBBox>
        </MDBBox>
      </MDBRow>
    </MDBContainer>
  );
};

export default UpcomingSectionV2;
